export const UPDATE_CHAT_INPUT = 'UPDATE_CHAT_INPUT';
export const TOGGLE_CHAT_PANEL_OPEN = 'TOGGLE_CHAT_PANEL_OPEN';
export const SET_CHAT_PANEL_OPEN = 'SET_CHAT_PANEL_OPEN';
export const SET_INPUT_FIELD_REF = 'SET_INPUT_FIELD_REF';
export const UPDATE_DOCUMENT_VISIBILITY = 'UPDATE_DOCUMENT_VISIBILITY';
export const LOAD_BRAND_TEXT = 'LOAD_BRAND_TEXT';
export const LOAD_BRAND_TEXT_SUCCESS = 'LOAD_BRAND_TEXT_SUCCESS';
export const SET_SHOW_INTRO = 'SET_SHOW_INTRO';
export const NAVIGATE_TO_INTRO = 'NAVIGATE_TO_INTRO';

export const updateChatInput = ({ value }) => ({
  type: UPDATE_CHAT_INPUT,
  value
});

export const toggleChatPanelVisible = () => ({
  type: TOGGLE_CHAT_PANEL_OPEN,
  shouldShowIntro: true
});

export const setChatPanelVisible = visible => ({
  type: SET_CHAT_PANEL_OPEN,
  visible
});

export const setInputFieldRef = ref => ({
  type: SET_INPUT_FIELD_REF,
  ref
});

export const updateDocumentVisibility = visible => ({
  type: UPDATE_DOCUMENT_VISIBILITY,
  visible
});

export const loadBrandText = () => ({
  type: LOAD_BRAND_TEXT
});

export const setShowIntro = show => ({
  type: SET_SHOW_INTRO,
  show
});

export const navigateToIntro = () => ({
  type: NAVIGATE_TO_INTRO
});



// WEBPACK FOOTER //
// ./src/reducers/ui/actions.js